import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BcReactComponent from '@bibliocommons/base-bc-react-component';

import BorrowingUtilityBar from '../../shared/BorrowingUtilityBar';
import { FormattedMessage } from 'react-intl';

import './RecentlyReturnedUtilityBar.scss';

export default class RecentlyReturnedUtilityBar extends BcReactComponent {

  renderTitle() {
    return (
      <span className="cp-borrowing-utility-bar-title">
        <h2>
          <span className="item_count_label">
            <FormattedMessage id="label_number_of_items" values={{ count: this.props.totalCount }} />
          </span>
        </h2>
      </span>
    );
  }

  render() {
    return (
      <BorrowingUtilityBar
        className="cp-recently-returned-utility-bar"
        printURL={this.props.printURL}
        title={this.renderTitle()}
        pagination={this.props.recentlyReturnedPaging}
        sortOptions={this.props.sortOptions} />
    );
  }
}

RecentlyReturnedUtilityBar.propTypes = {
  totalCount: PropTypes.number,
  sortOptions: ImmutablePropTypes.list,
  printURL: PropTypes.string,
  recentlyReturnedPaging: ImmutablePropTypes.map
};



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedUtilityBar/RecentlyReturnedUtilityBar.jsx